import { useSessionStorage as useBriqCommonSessionStorage } from '@briq/shared'
import { Dispatch, SetStateAction } from 'react'

export function useSessionStorage(
  key: string,
  initialValue = ''
): [string, Dispatch<SetStateAction<string>>, () => void] {
  return useBriqCommonSessionStorage(key, initialValue)
}
